<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./VertiNodeLevelPicker.translations.json";
	import type { VertiNodeLevel } from "../../../../core/schema/VertiNodeLevel.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { querySizeMappings } from "../../../shared/components/Picture/querySizeMappings.js";
	import collapse from "../../../../core/assets/icons/collapse.svg?raw";
	import Icon from "../../../shared/components/Icon.svelte";

	export let levels: VertiNodeLevel[];
	export let option: VertiNodeLevel["id"] | null = null;

	const { TENANT_LOCALE } = getGlobalSettings();

	const translate = getTranslate(translations);
	let open = false;
	let comp = null as HTMLElement | null;
	let windowWidth = 0;

	function toggle(): void {
		open = !open;
	}

	function close(): void {
		open = false;
	}

	function select(value: typeof option): void {
		option = value;
		close();
	}

	function outsideClick(event: MouseEvent): void {
		if (!comp?.contains(event.target as Node)) {
			close();
		}
	}

	// Checking 0 windowWidth in case of prerender
	$: desktopSize = windowWidth >= querySizeMappings.md || windowWidth === 0;
	$: options = [
		...(desktopSize
			? [
					{
						value: null,
						label: translate("allFeatures"),
					},
				]
			: []),
		...levels.map((level) => ({
			value: level.id,
			label: level.name[TENANT_LOCALE],
		})),
	];
	let selectedOption: (typeof options)[number] | undefined;
	$: {
		selectedOption = options.find(({ value }) => value === option);
		if (selectedOption === undefined) {
			option = (levels.find(({ name }) => name.en === "Integration") ?? levels[0])?.id ?? null;
			selectedOption = options.find(({ value }) => value === option);
		}
	}
</script>

<svelte:window on:click={outsideClick} bind:innerWidth={windowWidth} />

<div bind:this={comp} class="relative">
	<button on:click={toggle} class="bg-primary flex items-center gap-2 rounded-[.65rem] px-6 py-3 text-white shadow-xl">
		<span>{selectedOption?.label}</span>

		<Icon icon={collapse} class="w-2 transition-all {open ? 'rotate-180' : ''}" />
	</button>

	<div
		class="bg-primary border-primary absolute left-1/2 right-0 top-full z-10 flex min-w-max -translate-x-1/2 flex-col gap-px rounded-[.65rem] border text-white shadow-xl transition-all"
		class:opacity-0={!open}
		class:mt-2={open}
		class:pointer-events-none={!open}
	>
		{#each options as { label, value }}
			<button
				class="rounded-[inherit] px-6 py-3 transition-all hover:bg-white hover:text-black hover:shadow-xl"
				class:bg-white={option === value}
				class:text-black={option === value}
				class:shadow-xl={option === value}
				on:click={() => {
					select(value);
				}}
			>
				{label}
			</button>
		{/each}
	</div>
</div>
